import { createContext } from 'react'

export const initialState = {
    authToken: false,
    isCGUApproved: false
}

export const reducer = (state, action) => {
  switch (action.type) {
    case "set_auth_token":
      return { ...state, authToken: action.authToken }
    case "cgu_approved":
      return { ...state, isCGUApproved: true }
    default:
      return state
  }
}

export const bindActions = (dispatch) => {
  return {
    setAuthToken: authToken => dispatch({ type: 'set_auth_token', authToken }),
    CGUApproved: () => dispatch({ type: 'cgu_approved' })
  }
}

export const Context = createContext({})